import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AbstractService } from './abstract.service';
import { CorretorResposneDto } from '../dto/corretor-response.dto';
import { getCorretorText } from '../model/corretorTexto';

@Injectable({ providedIn: 'root' })
export class CorretorService extends AbstractService {
   private readonly URL = `${this.API_REST}/corretores`;

   constructor(http: HttpClient) {
      super(http);
   }

   async getCorretores(): Promise<CorretorResposneDto[]> {
      const response$ = this.http.get<CorretorResposneDto[]>(this.URL);
      const corretores = await firstValueFrom(response$);

      corretores.forEach((c) => {
        const extras = this.getExtras(c.codigo, c.creci);
        if(extras) {
            c.avatar = extras.avatarUrl;
            c.cargo = extras.cargo;
            c.bio = extras.bio;
        }
      });

      return corretores;
   }

   async getCorretorByCodigo(codigo: number): Promise<CorretorResposneDto | undefined> {
      const corretores = await this.getCorretores();
      return corretores.find((c) => c.codigo === codigo);
   }

   getExtras(codigo: number, creci: string) {
      const c = this.readList().find((l) => codigo === l.id);
      if (c) {
         return { cargo: c.cargo, avatarUrl: c.avatarUrl, bio: getCorretorText(creci) };
      }

      return null;
   }

   readList() {
      // Exportando a lista de corretores
      return [
         {
            id: 12,
            nome: 'Gabriel Fenalti',
            cargo: 'Corretor',
            email: 'gabriel@cancianimoveis.com',
            telefone: '(55) 99202-2824',
            rating: '76.207',
            avatarUrl: '../../assets/corretores/home/gabriel fenalti.jpg'
         },
         {
            id: 35,
            nome: 'Ana Luiza Mahl',
            cargo: 'Corretora',
            email: 'ana@cancianimoveis.com',
            telefone: '(55) 99145-0721',
            rating: '73.133',
            avatarUrl: '../../assets/corretores/home/anaa luiza mahl.jpg'
         },
         {
            id: 36,
            nome: 'Alessandro Correa',
            cargo: 'Corretor',
            email: 'alessandro@cancianimoveis.com',
            telefone: '(55) 99708-6868',
            rating: '58.274',
            avatarUrl: '../../assets/corretores/home/alessandro_correa.jpg'
         },
         {
            id: 37,
            nome: 'Beatriz Spibida',
            cargo: 'Corretora',
            email: 'beatriz@cancianimoveis.com',
            telefone: '(55) 99943-2769',
            rating: '37.549',
            avatarUrl: '../../assets/corretores/home/beatriz spibida.jpg'
         },
         {
            id: 39,
            nome: 'Claiverton Vieira',
            cargo: 'Corretor',
            email: 'claiverton@cancianimoveis.com',
            telefone: '(55) 99953-6300',
            rating: '65.569',
            avatarUrl: '../../assets/corretores/home/claiverton vieira.jpg'
         },
         {
            id: 40,
            nome: 'Carlos Alberto da Rosa Júnior',
            cargo: 'Corretor',
            email: 'carlosalberto@cancianimoveis.com',
            telefone: '(55) 99920-0392',
            rating: '68.615',
            avatarUrl: '../../assets/corretores/home/carlos alberto da rosa.jpg'
         },
         {
            id: 41,
            nome: 'Carlos Eduardo Cantarelli Brum',
            cargo: 'Corretor',
            email: 'carloseduardo@cancianimoveis.com',
            telefone: '(55) 99967-4115',
            rating: '53.992',
            avatarUrl: '../../assets/corretores/home/carlos eduardo.jpg'
         },
         {
            id: 44,
            nome: 'Estevan Pereira',
            cargo: 'Corretor',
            email: 'estevan@cancianimoveis.com',
            telefone: '(55) 99935-4631',
            rating: '58.559',
            avatarUrl: '../../assets/corretores/home/estevan pereira.jpg'
         },
         {
            id: 49,
            nome: 'Leandro Marques',
            cargo: 'Corretor',
            email: 'leandromarques@cancianimoveis.com',
            telefone: '(55) 99602-5070',
            rating: '56.746',
            avatarUrl: '../../assets/corretores/home/leandro marques.jpg'
         },
         {
            id: 50,
            nome: 'Lisângelo Mello',
            cargo: 'Corretor',
            email: 'lisangelo@cancianimoveis.com',
            telefone: '(55) 99945-6300',
            rating: '46.173',
            avatarUrl: '../../assets/corretores/home/lisângelo mello.jpg'
         },
         {
            id: 51,
            nome: 'Mariane Da Cas',
            cargo: 'Corretora',
            email: 'marianedacas@cancianimoveis.com',
            telefone: '(55) 99981-3981',
            rating: '67.472',
            avatarUrl: '../../assets/corretores/home/mariane da cás.jpg'
         },
         {
            id: 52,
            nome: 'Pietro Guerra',
            cargo: 'Corretor',
            email: 'pietro@cancianimoveis.com',
            telefone: '(55) 99707-9307',
            rating: '64.696',
            avatarUrl: '../../assets/corretores/home/pietro guerra.jpg'
         },
         {
            id: 53,
            nome: 'Rafael Leal',
            cargo: 'Corretor',
            email: 'rafael@cancianimoveis.com',
            telefone: '(55) 99989-9708',
            rating: '37.410',
            avatarUrl: '../../assets/corretores/home/rafael leal.jpg'
         },
         {
            id: 55,
            nome: 'Vanessa Zimermann',
            cargo: 'Corretora',
            email: 'vanessa.zimermann@cancianimoveis.com',
            telefone: '(55) 99949-1015',
            rating: '64.692',
            avatarUrl: '../../assets/corretores/home/vanessa zimermann.jpg'
         },
         {
            id: 57,
            nome: 'Weslei Till',
            cargo: 'Corretor',
            email: 'weslei@cancianimoveis.com',
            telefone: '(55) 99917-5793',
            rating: '66.786',
            avatarUrl: '../../assets/corretores/home/weslei till.jpg'
         },
         {
            id: 72,
            nome: 'Leonardo da Luz Ribeiro',
            cargo: 'Corretor',
            email: 'leonardo@cancianimoveis.com',
            telefone: '(55) 99255-7337',
            rating: '66.767',
            avatarUrl: '../../assets/corretores/home/leonardo ribeiro.jpg'
         },
         {
            id: 93,
            nome: 'Wagner de Lima Fonseca',
            cargo: 'Corretor',
            email: 'wagnerlima@cancianimoveis.com',
            telefone: '(55) 99700-9992',
            rating: '75.776',
            avatarUrl: '../../assets/corretores/home/wagner lima.jpg'
         },
         {
            id: 96,
            nome: 'Deividy de Almeida Eduardo',
            cargo: 'Corretor',
            email: 'deividy@cancianimoveis.com',
            telefone: '(55) 99136-2237',
            rating: '76.188',
            avatarUrl: '../../assets/corretores/home/deividy almeida.jpg'
         },
         {
            id: 97,
            nome: 'Angela Reis',
            cargo: 'Corretora',
            email: 'angela@cancianimoveis.com',
            telefone: '(55) 99137-4621',
            rating: '60.009',
            avatarUrl: '../../assets/corretores/home/angela reis.jpg'
         },
         {
            id: 144,
            nome: 'Dayane de Cassia Miler Paes',
            cargo: 'Corretora',
            email: 'dayane@cancianimoveis.com',
            telefone: '(55) 99935-1439',
            rating: '68.801',
            avatarUrl: '../../assets/corretores/home/dayane paes.jpg'
         },
         {
            id: 157,
            nome: 'William Henrique Dias',
            cargo: 'Corretor',
            email: 'william.dias@cancianimoveis.com',
            telefone: '(55) 99670-0424',
            rating: '68.003',
            avatarUrl: '../../assets/corretores/home/william dias.jpg'
         },
         {
            id: 165,
            nome: 'Leonardo Sangoi Copetti',
            cargo: 'Corretor',
            email: 'leonardo.copetti@cancianimoveis.com',
            telefone: '(55) 99989-0594',
            rating: '36.288',
            avatarUrl: '../../assets/corretores/home/leonardo copetti.jpg'
         },
         {
            id: 166,
            nome: 'Neila da Silva Fernandes Corrêa',
            cargo: 'Corretora',
            email: 'neila.fernandes@cancianimoveis.com',
            telefone: '(55) 99159-7237',
            rating: '77.362',
            avatarUrl: '../../assets/corretores/home/neila corrêa.jpg'
         },
         {
            id: 178,
            nome: 'Patrícia Martins',
            cargo: 'Corretora',
            email: 'patricia.martins@cancianimoveis.com',
            telefone: '(48) 99209-0337',
            rating: '80.637', // Sem rating informado
            avatarUrl: '../../assets/corretores/home/patricia martins.jpg'
         },
         {
            id: 190,
            nome: 'Marcelo Bellinaso',
            cargo: 'Corretor',
            email: 'marcelo.bellinaso@cancianimoveis.com',
            telefone: '(55) 99186-8483',
            rating: '81.371',
            avatarUrl: '../../assets/corretores/home/marcelo belinasso.jpg'
         },
         {
            id: 194,
            nome: 'Milany Cardoso Rios',
            cargo: 'Corretora',
            email: 'milany@cancianimoveis.com',
            telefone: '(55) 99144-0968',
            rating: '82.999',
            avatarUrl: '../../assets/corretores/home/milany rios.jpg'
         },
         {
            id: 210,
            nome: 'Arthur Henrique Ilha Knierim',
            cargo: 'Corretor',
            email: 'arthur.knierim@cancianimoveis.com',
            telefone: '(55) 99951-4342',
            rating: '82.979',
            avatarUrl: '../../assets/corretores/home/arthur knierim.jpg'
         },
         // {
         //     id: 214,
         //     nome: 'Mathias da Silva Reis',
         //     cargo: 'Corretor',
         //     email: 'mathias.reis@cancianimoveis.com',
         //     telefone: '(55) 99135-5319',
         //     rating: '73937 F',
         //     avatarUrl: '../../assets/corretores/mathias reis.jpg'
         // },
         {
            id: 216,
            nome: 'Henrique Bock',
            cargo: 'Corretor',
            email: 'henrique.bock@cancianimoveis.com',
            telefone: '(55) 99211-7993',
            rating: '82.986',
            avatarUrl: '../../assets/corretores/home/henrique bock.jpg'
         },
         {
            id: 219,
            nome: 'Felipe Falleiro Dos Santos',
            cargo: 'Corretor',
            email: 'felipe.santos@cancianimoveis.com',
            telefone: '(55) 99916-1958',
            rating: '82.497',
            avatarUrl: '../../assets/corretores/home/felipe falleiro.jpg'
         },
         {
            id: 225,
            nome: 'Mara Silveira',
            cargo: 'Corretora',
            email: 'mara.silveira@cancianimoveis.com',
            telefone: '(55) 99979-2717',
            rating: '66.771',
            avatarUrl: '../../assets/corretores/home/mara silveiro.jpg'
         },
         {
            id: 199,
            nome: 'Vilmar Martins dos Santos',
            cargo: 'Corretor',
            email: 'vilmar@cancianimoveis.com',
            telefone: '(99) 99999-9999',
            rating: 'N/A', // em processo
            avatarUrl: '../../assets/corretores/home/vilmar martins.jpg'
         },
         {
            id: 212,
            nome: 'Lucas Coden Azevedo',
            cargo: 'Corretor',
            email: 'lucas.azevedo@cancianimoveis.com',
            telefone: '(55) 99922-1114',
            rating: 'N/A', // em processo
            avatarUrl: '../../assets/corretores/home/lucascoden.jpg'
         }
      ];
   }
}
